function ImageSlider( sliderEl ){

  this.sliderEl = sliderEl;
  this.inputs = null;
  this.nextIndex = 1; //next index should be 1 to start
  this.timer = null;

  this.constructInputs();

}

ImageSlider.prototype.start = function () {
  this.timer = setInterval( () => this.slide( this.nextIndex ), 8000 );
};

ImageSlider.prototype.slide = function ( nextIndex ) {
  this.inputs[ nextIndex ].checked = true;
  nextIndex++;
  if( nextIndex >= this.inputs.length){
    nextIndex = 0;
  }
  this.nextIndex = nextIndex;
};

ImageSlider.prototype.constructInputs = function () {

  let inputs = [];

  [...this.sliderEl.children].forEach( function( child ){
    if( child.tagName == 'INPUT' ){
      inputs.push( child );
      //check if checked
      if( child.checked ){
        this.nextIndex = child.value;
      }
    }
  }.bind(this))

  this.inputs = inputs;
};

export default ImageSlider;
